<template>
<span>
    <div class="product-modal-overlay" v-if="selectedCategory" @click="selectedCategory = null">
        <div class="product-modal" @click.stop>
            <div class="container">
                <div v-if="selectedCategory === 'E-liquids'">
                    <h2>We are constantly updating our selection of premium e-liquids to make sure all our customers are satisfied!</h2>
                    <br/>
                    <h1>Call for juice selection:</h1>
                    <h1>(954) 530-1533</h1>
                    
                </div>
                <div v-else v-for="(product, index) in products[selectedCategory]" :key="index"><img :src="require(`../assets/brands/${product}.png`)"/></div>
            </div>
        </div>
    </div>
    <div class="categories">
        <div class="touple">
            <div 
                @click="selectedCategory = 'CBD Products'"
                class="card" 
                :style="{ backgroundImage : `url('${require('../assets/categories/CBD\ Products.jpg')}')` }"
            >
                <h3>CBD Products</h3>
            </div>
            <div 
                @click="selectedCategory = 'E-liquids'"
                class="card" 
                :style="{ backgroundImage : `url('${require('../assets/categories/E-liquids.jpg')}')` }"
            >
                <h3>E-Liquids</h3>
            </div>
        </div>
        <div class="touple">
            <div 
                @click="selectedCategory = 'Kits'"
                class="card" 
                :style="{ backgroundImage : `url('${require('../assets/categories/Kits.jpg')}')` }"
            >
                <h3>Kits</h3>
            </div>
            <div 
                @click="selectedCategory = 'Rebuildables'"
                class="card" 
                :style="{ backgroundImage : `url('${require('../assets/categories/Rebuildables.jpg')}')` }"
            >
                <h3>Rebuildables</h3>
            </div>
        </div>
        <div class="touple">
            <div 
                @click="selectedCategory = 'Pocket Vapes'"
                class="card" 
                :style="{ backgroundImage : `url('${require('../assets/categories/Pocket\ Vapes.jpg')}')` }"
            >
                <h3>Pocket Vapes</h3>
            </div>
            <div 
                @click="selectedCategory = 'Tanks'"
                class="card" 
                :style="{ backgroundImage : `url('${require('../assets/categories/Tanks.jpg')}')` }"
            >
                <h3>Tanks</h3>
            </div>
        </div>
        <div class="touple">
            <div 
                @click="selectedCategory = 'Dry Herb'"
                class="card" 
                :style="{ backgroundImage : `url('${require('../assets/categories/Dry\ Herb.jpg')}')` }"
            >
                <h3>Dry Herb</h3>
            </div>
            <div 
                @click="selectedCategory = 'Glass'"
                class="card" 
                :style="{ backgroundImage : `url('${require('../assets/categories/Glass.jpg')}')` }"
            >
                <h3>Glass</h3>
            </div>
        </div>
    </div>
    <div style="margin-bottom: 60px;"></div>
</span>
</template>

<script>
// @ is an alias to /src

import _ from 'lodash'
export default {
    name: 'home',
    data() {
        return {
            products: {
                'Kits': [
                    'smok', 
                    'dotmod', 
                    'eleaf',
                    'vaporesso',
                    'vapor storm',
                    'lost vape',
                    'aspire',
                    'voopoo',
                    'asmodus',
                    'geekvape',
                    'usv'
                ],
                'Tanks': [
                    'uwell',
                    'vaporesso',
                    'smok'
                ],
                'Pocket Vapes': [
                    'suorin',
                    'voopoo',
                    'lost vape',
                    'stig',
                    'smoking vapor',
                    'eon'
                ],
                'E-liquids': [],
                'CBD Products': [
                    'stubbees',
                    'sun state hemp',
                    'creating better days',
                    'koi',
                    'mary\'s nutritionals',
                    'high expedition',
                    'for the people',
                    'green roads',
                    'pure hemp',
                    'select cbd',
                    'recovr'
                ],
                'Rebuildables': [
                    'wotofo',
                    'geekvape',
                    'hellvape',
                    'sigelei',
                    'vaporesso',
                    'armageddon'
                ],
                'Glass': [
                    'grav',
                    'jane west',
                    'helix'
                ],
                'Dry Herb': [
                    'atmos',
                    'this thing rips',
                    'magic flight'
                ]
            },
			selectedCategory: null,
            pageBottom: null,
            showBottomNav: false,
            showOverlay: false
        }
    },
    methods: {
        scrollHandler: _.debounce(function() {
            let distanceFromBottom = (document.body.offsetHeight - window.innerHeight) - window.scrollY
            console.log(distanceFromBottom)
            console.log(document.body.offsetHeight)
            if (distanceFromBottom < 240) this.pageBottom = true
            else this.pageBottom = false
        }, 50)
    }
}
</script>
<style lang="scss">
@import url('https://fonts.googleapis.com/css?family=Nunito+Sans');

.product-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #000000aa;
    z-index: 3;
    display: flex;
    justify-content: center;
    align-items: center;
	font-family: Nunito Sans;
    .product-modal {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 80%;
        height: 90%;
        background: white;
        // border-radius: 10px;
        overflow: scroll;
        z-index: 4;
        img {
            margin: 20px;
            max-height: 100px;
        }
    }
}

.categories {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    .touple {
        width: 100%;
    }
    .card {
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
        font-family: Nunito Sans;
        font-size: 2em;
        position: relative;
        height: 100%;
        width: 100%;
        margin-right: 5%;
        margin-left: 5%;
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        &:hover {
            cursor: pointer;
        }
    }
}

.cat-icon {
    width: 60px;
    height: 60px;
    border-radius: 100%;
    background-color: white;
    margin-left: 20px;
    margin-right: 20px;
    margin-top: 40px;
    margin-bottom: 40px;
    box-shadow: 0 4px 8px 0 rgba(0,0,0,0.5);
    transition: all 0.2s ease;
}

.cat-icon.selected {
    background-color: pink;
    width: 80px;
    height: 80px;
    margin-bottom: 20px;
    margin-top: 20px;
    transition: all 0.2s ease;
}

.cat-icon:hover {
    box-shadow: 0 8px 16px 0 rgba(0,0,0,0.5);
    width: 80px;
    height: 80px;
    margin-bottom: 20px;
    transition: all 0.2s ease;
    background: grey;
}

.container {
	display: flex;
	flex-wrap: wrap;
    widht: 90%;
	justify-content: center;
    transition: all 1s ease;
    h2 {
        font-family: 'Nunito Sans';
        font-weight: bold;
        font-size: 24px;
        margin-bottom: 10px;
        text-align: center;
        padding-left: 60px;
        padding-right: 60px;
    }
}

.container.page-bottom {
    margin-bottom: 10px !important;
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
    transition: all 1s ease;
}

.show-nav {
    background: red;
}

.bottom-nav {
    background: blue;
	display: flex;
    justify-content: center;
    flex-wrap: wrap;
	overflow: hidden; 
	position: fixed; 
	width: 100%;
    bottom: 0;
    align-items: center;
    overflow: visible;
    transition: all 1s ease;
    animation-duration: 1s;
    animation-name: slide_up;
}

.hidden {
    display: none;
}

@keyframes slide_up {
    from { top: 0% }
    to { top: 100% }
}

.bottom-nav.page-bottom {
    position: relative; 
    transition: all 1s ease;
}

@media screen and (max-width: 768px) {
    .categories {
        .touple {
            margin: 0;
            .card {
                margin-left: 0;
                margin-right: 0;
            }
        }
    }
}
</style>
